import {BASE_API_URL} from '../constants'
import Token from "./Token";


export const UserSettingsApi = {
    get: () => {
        return fetch(
            BASE_API_URL + '/api/user-settings',
            {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + Token.getToken()
                }
            },
        ).then(r => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
    put: (payload) => {
        let url = BASE_API_URL + '/api/user-settings'
        return fetch(url, {
            method: 'PUT',
            headers: {
                Authorization: 'Bearer ' + Token.getToken(),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        }).then(r => {
            if (r.ok) {
                return r
            }
            throw new Error(r.statusText)
        })
    }
}